import React, { useCallback, useState } from "react";
import { Modal, Button, Typography, Space } from "antd";
import { useSelector } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { useDropzone } from "react-dropzone";
import ImportResultsModal from "./ImportResultsModal";
import DropzoneWrapper from "../../../components/util/Dropzone.style";
import { ReactComponent as CloudImg } from "../../../assets/img-cloud.svg";
import { uploadOrderImportBatchFile } from "../../../api/server";
const { Title, Text } = Typography;

const NewOrdersImport = (props) => {
  const { hide, visible } = props;
  const [files, setFiles] = useState([]);
  const [results, setResults] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  const onDrop = useCallback((acceptedFiles) => {
    // Take only the last dropped file
    const file = acceptedFiles[acceptedFiles.length - 1];
    if (file) {
      const newFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
        fileName: file.name,
      });
      setFiles([newFile]); // Replace existing files with new one
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: 10485760,
    multiple: false,
  });

  const onCloseResults = () => {
    setResults(null); // Reset results when closing results view
    setFiles([]);
    hide();
  };

  const onUpload = async () => {
    setIsUploading(true);
    try {
      for (let i = 0; i < files.length; i++) {
        const params = {
          file: files[i],
          scopePrefix,
        };
        const action = await uploadOrderImportBatchFile(params);
        const items = action?.lines || [];
        if (!action.error) {
          setResults(items);
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setIsUploading(false);
    }
  };

  return results ? (
    <ImportResultsModal
      visible={visible}
      onClose={onCloseResults}
      results={results}
    />
  ) : (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: "20px 100px",
        },
      }}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={() => {
              hide();
              setFiles([]);
            }}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0",
            textAlign: "center",
          }}
        >
          <FormattedMessage id="app.actions.uploadTitle" />
        </Title>

        <DropzoneWrapper>
          <div
            {...getRootProps({ className: "outer" })}
            style={{ padding: "0 60px" }}
          >
            <CloudImg />
            <input {...getInputProps()} />
            <p className="title">
              {<FormattedMessage id="app.actions.dragAndDropOrdersImport" />}
            </p>
            <p className="subtitle">
              {<FormattedMessage id="app.actions.dragAndDropBtl2" />}
            </p>
            <p className="limit">
              {
                <FormattedMessage
                  id={
                    process.env.REACT_APP_CONFIG === "matav"
                      ? "app.actions.dragAndDropMatav3"
                      : "app.actions.dragAndDrop3"
                  }
                />
              }
            </p>
          </div>
          <div className="filesContainer">
            {files.length > 0 ? (
              <Title level={3} style={{}}>
                {<FormattedMessage id="app.titles.files" />}
              </Title>
            ) : null}
            {files.map((f) => (
              <Text key={f.path}>{f.name}</Text>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "10px",
            }}
          >
            <div>
              <Button
                disabled={files.length < 1 || isUploading}
                type="primary"
                htmlType="submit"
                loading={isUploading}
                onClick={onUpload}
                size="large"
              >
                {<FormattedMessage id="app.actions.uploadFile" />}
              </Button>
              <Button
                style={{ margin: "0 10px" }}
                onClick={() => {
                  setFiles([]);
                  hide();
                }}
                size="large"
                disabled={isUploading}
              >
                {<FormattedMessage id="app.actions.cancel" />}
              </Button>
            </div>
          </div>
        </DropzoneWrapper>
      </div>
    </Modal>
  );
};

export default NewOrdersImport;
